import { render, staticRenderFns } from "./Proposta.vue?vue&type=template&id=18a187ed&scoped=true"
import script from "./Proposta.vue?vue&type=script&lang=js"
export * from "./Proposta.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=18a187ed&prod&scoped=true&lang=scss&external"
import style1 from "./Proposta.vue?vue&type=style&index=1&id=18a187ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a187ed",
  null
  
)

export default component.exports